import React, { useState } from 'react';
import { Car, Bike, Truck, Check, Loader2, Power } from 'lucide-react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

const VEHICLES = [
  { key: 'foot', label: 'רגלי / קורקינט', icon: Bike },
  { key: 'motorcycle', label: 'אופנוע', icon: Bike },
  { key: 'car', label: 'רכב פרטי', icon: Car },
  { key: 'van', label: 'מסחרי / ואן', icon: Truck },
];

/**
 * פאנל הרשמה כשליח + מתג זמינות. מוצג בתוך הפרופיל.
 * @param userData - אובייקט המשתמש
 * @param isOnline / onToggleOnline - נשלטים מ-MainApp (כי השידור גלובלי)
 */
export default function CourierModePanel({ userData, isOnline, onToggleOnline }) {
  const isCourier = !!userData?.courierInfo;
  const [registering, setRegistering] = useState(false);
  const [vehicle, setVehicle] = useState(userData?.courierInfo?.vehicle || 'car');
  const [saving, setSaving] = useState(false);

  const handleRegister = async () => {
    setSaving(true);
    try {
      await updateDoc(doc(db, 'users', userData.uid), {
        courierInfo: { vehicle, registeredAt: Date.now() },
        isCourier: true,
      });
      setRegistering(false);
      alert('נרשמת כשליח! מעכשיו תוכל לעבור למצב מקוון ולקבל משלוחים.');
    } catch (e) {
      console.error(e);
      alert('שגיאה בהרשמה');
    } finally {
      setSaving(false);
    }
  };

  if (!isCourier && !registering) {
    return (
      <div className="bg-blue-50 border border-blue-100 rounded-2xl p-5 text-center">
        <div className="bg-blue-600 w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3">
          <Car className="text-white" size={24} />
        </div>
        <h3 className="font-bold text-gray-800 mb-1">רוצה להרוויח כשליח?</h3>
        <p className="text-xs text-gray-500 mb-4">קבל משלוחים באזורך והרווח כסף בזמן הפנוי שלך.</p>
        <button onClick={() => setRegistering(true)} className="w-full bg-black text-white py-3 rounded-xl font-bold active:scale-95 transition-transform">
          הצטרף כשליח
        </button>
      </div>
    );
  }

  if (registering) {
    return (
      <div className="bg-white border border-gray-200 rounded-2xl p-5">
        <h3 className="font-bold text-gray-800 mb-3">באיזה כלי רכב תשתמש?</h3>
        <div className="grid grid-cols-2 gap-2 mb-4">
          {VEHICLES.map((v) => {
            const Icon = v.icon;
            return (
              <button
                key={v.key}
                onClick={() => setVehicle(v.key)}
                className={`p-3 rounded-xl border flex flex-col items-center gap-1 transition-all ${
                  vehicle === v.key ? 'bg-black text-white border-black' : 'bg-gray-50 text-gray-600 border-gray-200'
                }`}
              >
                <Icon size={20} />
                <span className="text-xs font-bold">{v.label}</span>
              </button>
            );
          })}
        </div>
        <button onClick={handleRegister} disabled={saving} className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold flex items-center justify-center gap-2 active:scale-95">
          {saving ? <Loader2 className="animate-spin" /> : <>אישור והרשמה <Check size={18} /></>}
        </button>
        <button onClick={() => setRegistering(false)} className="w-full mt-2 py-2 text-gray-400 text-sm">ביטול</button>
      </div>
    );
  }

  // שליח רשום — מתג זמינות
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-gray-800">מצב שליח</h3>
        <span className="text-xs bg-gray-100 text-gray-500 px-2 py-1 rounded-full">
          {VEHICLES.find((v) => v.key === userData.courierInfo?.vehicle)?.label}
        </span>
      </div>
      <button
        onClick={onToggleOnline}
        className={`w-full py-3 rounded-xl font-bold flex items-center justify-center gap-2 transition-all ${
          isOnline ? 'bg-green-500 text-white shadow-lg shadow-green-200' : 'bg-gray-100 text-gray-500'
        }`}
      >
        <Power size={18} />
        {isOnline ? 'מקוון — מקבל משלוחים' : 'לא מקוון'}
      </button>
      <p className="text-[11px] text-gray-400 text-center mt-2">
        במצב מקוון המיקום שלך משודר לשולחים בזמן אמת. הוא נמחק ברגע שתעבור ללא־מקוון.
      </p>
    </div>
  );
}
